import React from "react";
import {Col, Image, ListGroup, Row} from "react-bootstrap";
import {MediaItemJson} from "../interfaces";
import {Download, Icon} from 'react-bootstrap-icons';
import iconBackground from './images/icon_background.png'

interface MediaListItemProps {
    mediaItemJson: MediaItemJson,
    MediaIcon: Icon,

    onClickDownload(mediaItemJson: MediaItemJson),
}

export const MediaListItem = ({mediaItemJson, MediaIcon, onClickDownload}: MediaListItemProps) =>
    <ListGroup.Item>
        <Row>
            <Col sm={4}>
                <div style={{position: 'relative', width: '92px'}}>
                    <Image style={{display: 'block', height: '82px', width: '92px'}} src={iconBackground}/>
                    <MediaIcon size={'100%'} style={{position: 'absolute', bottom: '0', left: '0', color: '#e30171'}}/>
                </div>
            </Col>
            <Col>
                <div style={{color: '#605faa', fontWeight: 'bold', fontSize: '14px'}}>{mediaItemJson.filename}</div>
                <div
                    style={{color: '#808080', fontWeight: 'bold', fontSize: '13px'}}>{mediaItemJson.contentLength} bytes
                </div>
                <div style={{textAlign: 'right', marginTop: '10px', cursor: 'pointer'}}><Download
                    onClick={() => onClickDownload(mediaItemJson)}
                    style={{width: '27px', height: '27px'}}/>
                </div>
            </Col>
        </Row>
    </ListGroup.Item>;
